import { render, staticRenderFns } from "./DetailsAbholung.vue?vue&type=template&id=bc338a8a"
import script from "./DetailsAbholung.vue?vue&type=script&lang=ts"
export * from "./DetailsAbholung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports